import Column from '@amzn/meridian/column';
import Loader from '@amzn/meridian/loader';
import Row from '@amzn/meridian/row';
import React from 'react';
import { RETURN_REASON } from '../../../../constants';
import { Select, SelectOption, Text, TranslatedString, Input, Link } from '../../../blocks/localization';
import { Delete } from '../../../icons';
import { HelpPopover } from '../../HelpPopover';
import { MultilineFormEditorColumnFormat } from '../MultilineFormEditor';

export const createReturnOrderPageReturnReasonFormat = (options: {
    isLoading?: (item: any) => boolean;
    getReasonText: (reasonValue: string) => TranslatedString;
    getComplianceReasonExplainer?: (reasonValue: string) => TranslatedString;
    customReasonPlaceholder: TranslatedString;
    returnReasonPlaceholder: TranslatedString;
    reasonOptions: { value: string; label: TranslatedString }[];
}): MultilineFormEditorColumnFormat => ({
    render: (item, _, lineIndex, onChange) => {
        if (options.isLoading && options.isLoading(item)) {
            return (
                <Column alignmentHorizontal={'center'}>
                    <Loader size={'small'} />
                </Column>
            );
        }

        if (item.complianceResult) {
            const value = options.getReasonText(item.complianceResult);
            const explainer = options.getComplianceReasonExplainer?.(item.complianceResult);
            return (
                <Row spacing={'small'} alignmentVertical={'center'}>
                    <Text alignment={'left'}>{value}</Text>
                    {explainer && <HelpPopover text={explainer} />}
                </Row>
            );
        }

        return (
            <Row spacing={'small'}>
                {(item.returnReason as RETURN_REASON) === RETURN_REASON.OTHER ? (
                    <Input
                        value={item.customReason || ''}
                        placeholder={options.customReasonPlaceholder}
                        onChange={(value) => onChange('customReason', lineIndex)(value)}
                    />
                ) : (
                    <Select
                        value={item.returnReason}
                        placeholder={options.returnReasonPlaceholder}
                        onChange={onChange('returnReason', lineIndex)}
                        width={200}
                    >
                        {options.reasonOptions.map((option) => (
                            <SelectOption key={option.value} value={option.value} label={option.label} />
                        ))}
                    </Select>
                )}
                {item.returnReason !== RETURN_REASON.NONE && (
                    <Link
                        type={'secondary'}
                        onClick={() => {
                            onChange('returnReason', lineIndex)(RETURN_REASON.NONE);
                        }}
                    >
                        <Delete color={'#545b64'} />
                    </Link>
                )}
            </Row>
        );
    },
});
